import TranslationEditForm from "./components/Form";
import { observer } from "mobx-react";
import React from "react";

const TranslationEditScene = observer(() => <TranslationEditForm />);

export default TranslationEditScene;
